(function () {
  'use strict';

  // === CONFIG ===
  // Les règles sont chargées depuis le métaobjet Shopify `gift_code_rule`
  // (rendu en JSON dans layout/theme.liquid → window.__GIFT_RULES).
  // Le fallback ci-dessous sert uniquement si le métaobjet n'existe pas (dev local).
  const FALLBACK_RULES = {
    
  };
  const GIFT_RULES = (window.__GIFT_RULES && Object.keys(window.__GIFT_RULES).length)
    ? window.__GIFT_RULES
    : FALLBACK_RULES;

  const GIFT_PROP = '_gift_code';
  const DEBUG = false;
  const log = (...a) => DEBUG && console.log('[gift-with-code]', ...a);

  let busy = false;

  function hasOfferBfCookie() {
    return /(?:^|;\s*)offre=bf(?:;|$)/.test(document.cookie);
  }

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  function readCodeFromDOM() {
    const el = document.querySelector('#scDiscountApp .code-name, .sc_code-info .code-name');
    return el ? el.textContent.trim().toUpperCase() : null;
  }

  function getActiveCode(cart) {
    const native = (cart.discount_codes || [])
      .filter(d => d.applicable !== false)
      .map(d => (d.code || '').toUpperCase())
      .find(c => GIFT_RULES[c]);
    if (native) return native;

    const dom = readCodeFromDOM();
    if (dom && GIFT_RULES[dom]) return dom;

    return null;
  }

  function giftLinesFor(cart, code) {
    return cart.items.filter(
      item => item.properties && item.properties[GIFT_PROP] === code
    );
  }

  // Liste des produits offerts d'une règle (1 ou plusieurs). Compat : les anciennes règles
  // n'ont que productHandle/fallbackVariantId au niveau racine.
  function ruleProducts(rule) {
    if (Array.isArray(rule.products) && rule.products.length) return rule.products;
    return [{ handle: rule.productHandle, fallbackVariantId: rule.fallbackVariantId }];
  }

  function paidUnitsOfGiftProduct(cart, rule, code) {
    const primaryHandle = ruleProducts(rule)[0].handle;
    return cart.items
      .filter(it =>
        !(it.properties && it.properties[GIFT_PROP] === code) &&
        (primaryHandle ? it.handle === primaryHandle : true)
      )
      .reduce((sum, it) => sum + it.quantity, 0);
  }

  function shouldAddGift(rule, cart, code) {
    const threshold = rule.skipIfPaidUnitsAtLeast != null ? rule.skipIfPaidUnitsAtLeast : Infinity; // pas de ?? : Safari < 13.1
    const units = paidUnitsOfGiftProduct(cart, rule, code);
    if (units >= threshold) {
      log('skip add: paid units already >= threshold', { units, threshold });
      return false;
    }
    return true;
  }

  const productCache = {};
  async function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    const r = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!r.ok) return null;
    const p = await r.json();
    productCache[handle] = p;
    return p;
  }

  // Détection de taille robuste : S, M, L, XS, XXS, XXXS, XL, XXL, XXXL, 2XL..9XL, 2XS..9XS
  const SIZE_RE = /^(x{1,3}s|s|m|l|x{1,3}l|[0-9]+xl|[0-9]+xs)$/i;
  function isSize(v) { return SIZE_RE.test(String(v).trim()); }

  function variantOptions(v) {
    if (Array.isArray(v.options)) return v.options.filter(Boolean);
    return [v.option1, v.option2, v.option3].filter(Boolean);
  }

  function detectSize(values) {
    return values.map(String).find(v => isSize(v)) || null;
  }

  // Retourne l'id de variante cadeau à ajouter POUR UN PRODUIT de la règle
  // (`prod` = { handle, fallbackVariantId }), ou NULL si rien ne doit être ajouté
  // (notamment si la taille du panier est en RUPTURE -> pas de substitution).
  async function resolveGiftVariantId(prod, cart, code, preProduct) {
    if (!prod.handle || prod.handle === 'REMPLIR-HANDLE-ICI') {
      return prod.fallbackVariantId;
    }

    const product = preProduct || await getProduct(prod.handle);
    if (!product) {
      log('gift product not found, fallback', { handle: prod.handle });
      return prod.fallbackVariantId;
    }
    const isAvailable = (id) => { const v = product.variants.find(x => x.id === id); return !!(v && v.available); };
    const fallbackOrNull = () => isAvailable(prod.fallbackVariantId) ? prod.fallbackVariantId : null;

    const paidItem = cart.items.find(it => !(it.properties && it.properties[GIFT_PROP] === code));
    // Aucun article payant (panier vide / que des cadeaux) -> on N'ajoute PAS de cadeau.
    // (Permet de pré-appliquer le code sur panier vide via fetch sans ajouter de cadeau parasite.)
    if (!paidItem) { log('no paid item -> no gift'); return null; }

    // Cadeau SANS taille (ex. une pochette) : aucune taille à faire correspondre -> variante de repli
    if (!product.variants.some(v => variantOptions(v).some(isSize))) {
      log('gift product without size -> fallback', { handle: prod.handle });
      return fallbackOrNull();
    }

    let cartSize = null;
    if (paidItem) {
      let cartOpts = [paidItem.option1, paidItem.option2, paidItem.option3].filter(Boolean);
      if (!cartOpts.length && Array.isArray(paidItem.variant_options)) cartOpts = paidItem.variant_options.filter(Boolean);
      if (!cartOpts.length && paidItem.variant_title) cartOpts = paidItem.variant_title.split(/\s*\/\s*/).filter(Boolean);
      cartSize = detectSize(cartOpts);
    }

    // Pas de taille détectée -> on prend le fallback UNIQUEMENT s'il est en stock, sinon rien
    if (!cartSize) {
      log('no size detected -> fallback if available');
      return fallbackOrNull();
    }

    const fallbackVariant = product.variants.find(v => v.id === prod.fallbackVariantId);
    const fallbackOpts = fallbackVariant ? variantOptions(fallbackVariant) : [];
    const fallbackNonSize = fallbackOpts.filter(o => !isSize(o));

    const targetSize = cartSize.toLowerCase();
    log('resolve', {
      code: code,
      cartSize: cartSize,
      fallbackNonSize: fallbackNonSize,
      giftAvailable: product.variants.filter(v => v.available).map(v => variantOptions(v).join('/')),
    });
    const match = product.variants.find(v => {
      if (!v.available) return false; // variante en stock uniquement
      const opts = variantOptions(v).map(o => String(o).toLowerCase());
      if (!opts.includes(targetSize)) return false;
      return fallbackNonSize.every(o => opts.includes(String(o).toLowerCase())); // garde le pack (ex: "1 shorty menstruel")
    });

    if (match) {
      log('matched gift variant by size', { size: cartSize, variantId: match.id });
      return match.id;
    }

    // Taille du panier en RUPTURE pour le cadeau -> sentinelle 'OOS' (message + ni ajout ni code)
    log('size out of stock -> NO gift', { size: cartSize });
    return 'OOS';
  }

  // Variante cadeau pour une TAILLE donnée (et non depuis le panier), pour UN produit de la
  // règle (`prod` = { handle, fallbackVariantId }). Sert à injecter le cadeau DANS LA MÊME
  // requête /cart/add.js que le produit éligible (ajout instantané, un seul rendu).
  function resolveGiftVariantForSize(prod, size, product) {
    if (!prod.handle || prod.handle === 'REMPLIR-HANDLE-ICI') return prod.fallbackVariantId;
    if (!product) return prod.fallbackVariantId;
    const isAvailable = (id) => { const v = product.variants.find(x => x.id === id); return !!(v && v.available); };
    const fallbackOrNull = () => isAvailable(prod.fallbackVariantId) ? prod.fallbackVariantId : null;
    // Cadeau sans taille (ex. une pochette) : on prend directement la variante de repli
    if (!product.variants.some(v => variantOptions(v).some(isSize))) return fallbackOrNull();
    if (!size || !isSize(size)) return fallbackOrNull();
    const fallbackVariant = product.variants.find(v => v.id === prod.fallbackVariantId);
    const fallbackNonSize = (fallbackVariant ? variantOptions(fallbackVariant) : []).filter(o => !isSize(o));
    const targetSize = String(size).toLowerCase();
    const match = product.variants.find(v => {
      if (!v.available) return false;
      const opts = variantOptions(v).map(o => String(o).toLowerCase());
      if (!opts.includes(targetSize)) return false;
      return fallbackNonSize.every(o => opts.includes(String(o).toLowerCase()));
    });
    return match ? match.id : 'OOS';
  }

  // Items cadeau à injecter dans le /cart/add.js du produit éligible (appelé par product-form.js).
  // `options` = options de la variante choisie du produit (pour détecter la taille).
  // Retourne [] si rien à ajouter (rupture -> le flux normal affichera le message + code DESOLE).
  // Tout-ou-rien : si la taille d'UN des produits offerts est en rupture, aucun n'est injecté.
  async function giftItemsForAdd(code, options) {
    code = (code || '').toUpperCase();
    const rule = GIFT_RULES[code];
    if (!rule || hasOfferBfCookie()) return [];
    const size = detectSize((options || []).map(String));
    const items = [];
    for (const prod of ruleProducts(rule)) {
      const product = await getProduct(prod.handle);
      const variantId = resolveGiftVariantForSize(prod, size, product);
      if (!variantId || variantId === 'OOS') return [];
      items.push({ id: variantId, quantity: rule.quantity || 1, code: code });
    }
    return items;
  }

  // === Message client "taille du cadeau en rupture" (inséré sous le champ "Code promo" du panier) ===
  // Le texte courant à afficher (null = aucun message). Source de vérité unique : tant qu'il est défini,
  // le message est (ré)inséré à chaque rendu du panier (y compris nos propres refreshCartUI), donc il NE
  // disparaît PAS quand on rafraîchit pour appliquer le code de repli. Il est retiré uniquement quand :
  //  - le cadeau finit par être ajouté (clearOosMessage), ou
  //  - un rendu natif du thème (action utilisateur sur le panier) l'efface sans le réinsérer, ou
  //  - sécurité : expiration après 30s, ou rechargement de page.
  var OOS_INLINE_STYLE = 'margin:15px 0 0;font-size:12px;line-height:1.3;color:#9b1c1c;text-align:center;opacity:.9';
  var OOS_TOAST_STYLE = 'position:fixed;z-index:1000000;left:50%;top:16px;transform:translateX(-50%);background:rgba(0,0,0,.82);color:#fff;padding:7px 13px;border-radius:8px;font-size:12px;max-width:90vw;text-align:center';
  let oosMsgText = null;
  let oosMsgTimer = null;

  // Visible à l'écran ? (getClientRects = 0 si display:none dans la chaîne, ou taille nulle).
  // Fiable sur iOS Safari, y compris pour les drawers en position:fixed (offsetParent y serait null à tort).
  function oosIsVisible(el) {
    return !!(el && el.getClientRects && el.getClientRects().length > 0);
  }
  // Premier élément RÉELLEMENT VISIBLE qui matche le sélecteur (le thème a un markup mobile + un desktop
  // masqué : querySelector tomberait souvent sur la version cachée -> message inséré dans du display:none).
  function oosFirstVisible(sel) {
    var list = document.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) if (oosIsVisible(list[i])) return list[i];
    return null;
  }

  // (Ré)insère le message s'il doit être visible et qu'il n'est pas déjà dans le DOM.
  function renderOosMessage() {
    if (!oosMsgText) return;
    if (document.getElementById('gwc-oos-msg')) return; // déjà présent
    var msg = document.createElement('div');
    msg.id = 'gwc-oos-msg';
    msg.textContent = oosMsgText;
    msg.setAttribute('style', OOS_INLINE_STYLE);

    // 1) Ancre STABLE et toujours présente dans le markup : juste AVANT le bloc CTA (.cart__ctas),
    //    c.-à-d. directement sous le champ "Code promo" Selly. (On évite #scDiscountApp : injecté en
    //    asynchrone par Selly -> au moment du rendu il n'existe pas encore et le message partait tout en haut.)
    var ctas = oosFirstVisible('.cart__ctas');
    if (ctas && ctas.parentNode) { ctas.parentNode.insertBefore(msg, ctas); return; }

    var checkout = oosFirstVisible('#CartDrawer-Checkout');
    if (checkout && checkout.parentNode) { checkout.parentNode.insertBefore(msg, checkout); return; }

    // 2) Sinon, après le champ code promo s'il est déjà là.
    var app = oosFirstVisible('#scDiscountApp, .scDiscount');
    if (app && app.parentNode) { app.parentNode.insertBefore(msg, app.nextSibling); return; }

    var input = oosFirstVisible('.cart-drawer__footer input[type="text"], input[name*="discount" i], input[placeholder*="promo" i]');
    var row = input && (input.closest('form') || input.parentElement);
    if (oosIsVisible(row) && row.parentNode) { row.parentNode.insertBefore(msg, row.nextSibling); return; }

    // 3) Dernier recours : toast flottant (mobile / panier fermé).
    msg.setAttribute('style', OOS_TOAST_STYLE);
    document.body.appendChild(msg);
  }

  // Efface définitivement le message (cadeau finalement ajouté, ou reset).
  function clearOosMessage() {
    oosMsgText = null;
    if (oosMsgTimer) { clearTimeout(oosMsgTimer); oosMsgTimer = null; }
    var el = document.getElementById('gwc-oos-msg');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function showGiftUnavailable(name) {
    var tpl = window.__GIFT_OOS_MSG || 'Malheureusement votre taille de [produit] n’est plus disponible';
    oosMsgText = tpl.replace(/\[produit\]/gi, name || '').replace(/\s{2,}/g, ' ').trim();
    renderOosMessage();
    // Survie aux re-renders natifs (ouverture du panier sur ajout) pendant la phase active.
    var iv = setInterval(renderOosMessage, 200);
    setTimeout(function () { clearInterval(iv); }, 4000);
    // Sécurité : ne pas laisser le message "hanter" le panier indéfiniment.
    if (oosMsgTimer) clearTimeout(oosMsgTimer);
    oosMsgTimer = setTimeout(clearOosMessage, 30000);
  }

  // Applique un code promo de repli en passant par le champ de l'app Selly (#scDiscountApp),
  // comme le ferait l'utilisateur : on saisit le code puis on clique "Appliquer". Selly recalcule
  // et le thème bascule sur le footer "aveccode" qui montre le total remisé.
  async function applyCodeViaSelly(code) {
    // IMPORTANT : ne renvoyer que des éléments VISIBLES. Le thème duplique le markup panier
    // (version desktop masquée + version mobile) -> querySelector tomberait sur le champ CACHÉ
    // (vide, contrôlé par React donc revient à '' , et sans bouton "Appliquer" à côté).
    function findInput() {
      var sels = [
        '#scDiscountApp input[type="text"]', '#scDiscountApp input:not([type])',
        '.scDiscount input[type="text"]',
        'input[placeholder*="promo" i]', 'input[placeholder*="code" i]'
      ];
      for (var i = 0; i < sels.length; i++) {
        var list = document.querySelectorAll(sels[i]);
        for (var j = 0; j < list.length; j++) if (oosIsVisible(list[j])) return list[j];
      }
      return null;
    }
    function findApplyBtn(input) {
      var scope = (input && input.closest('#scDiscountApp, .scDiscount, .cart-drawer__footer, form')) ||
                  oosFirstVisible('#scDiscountApp, .scDiscount') || document;
      // Selly rend parfois "Appliquer" comme <button>, mais aussi comme <div>/<a>/<span> cliquable.
      // 1) vrais boutons d'abord
      var btns = scope.querySelectorAll('button, [role="button"], input[type="submit"]');
      for (var i = 0; i < btns.length; i++) {
        if (!oosIsVisible(btns[i])) continue;
        var t = (btns[i].textContent || btns[i].value || '').trim().toLowerCase();
        if (/appliqu|apply|valid|anwend|einlös|toepass|aplica|applica|zastos|aplik|tillämp|använd|anvand|použí|pouzi|alkalmaz|primeni|primijen|uporab/.test(t)) return btns[i];
      }
      // 2) tout élément cliquable (texte court) qui dit "Appliquer/Apply/Valider"
      var all = scope.querySelectorAll('a, div, span, button, [role="button"]');
      for (var j = 0; j < all.length; j++) {
        if (!oosIsVisible(all[j])) continue;
        var tt = (all[j].textContent || '').trim().toLowerCase();
        if (tt && tt.length <= 18 && /^(appliqu|apply|valid|anwend|einlös|toepass|aplica|applica|zastos|aplik|tillämp|använd|anvand|použí|pouzi|alkalmaz|primeni|primijen|uporab)/.test(tt)) return all[j];
      }
      // 3) sinon, premier vrai bouton visible du scope
      for (var k = 0; k < btns.length; k++) if (oosIsVisible(btns[k])) return btns[k];
      return null;
    }
    log('applyCodeViaSelly: start', { code });
    // L'app Selly est ré-injectée en asynchrone (notre panier vient d'être rendu) -> on attend le champ.
    var input = null;
    for (var n = 0; n < 40 && !input; n++) {
      input = findInput();
      if (!input) await new Promise(function (r) { setTimeout(r, 100); });
    }
    if (!input) {
      log('applyCodeViaSelly: NO Selly input found -> fallback /discount natif', { code });
      // Pas de champ Selly trouvé -> repli "natif" : applique quand même le code (visible au checkout).
      try { await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); await refreshCartUI(); } catch (e) {}
      return false;
    }
    // Pose la valeur d'un input contrôlé (React/Vue) de façon que le framework la "voie" :
    // setter natif (instance OU prototype) + reset du _valueTracker de React (sinon React
    // considère qu'il n'y a pas de changement, ignore notre saisie et REMET le champ à vide).
    function setNativeValue(el, value) {
      var protoSetter = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(el), 'value');
      var ownSetter = Object.getOwnPropertyDescriptor(el, 'value');
      if (ownSetter && protoSetter && ownSetter.set !== protoSetter.set) protoSetter.set.call(el, value);
      else if (protoSetter && protoSetter.set) protoSetter.set.call(el, value);
      else el.value = value;
      if (el._valueTracker) el._valueTracker.setValue(value === '' ? 'x' : '');
    }
    // Simule une VRAIE frappe clavier, caractère par caractère (c'est le seul truc fiable :
    // poser la valeur d'un coup est souvent ignoré/annulé par Selly).
    async function typeInto(el, text) {
      el.focus();
      el.click();
      setNativeValue(el, '');
      el.dispatchEvent(new Event('input', { bubbles: true }));
      for (var i = 0; i < text.length; i++) {
        var ch = text[i];
        el.dispatchEvent(new KeyboardEvent('keydown', { bubbles: true, cancelable: true, key: ch }));
        el.dispatchEvent(new KeyboardEvent('keypress', { bubbles: true, cancelable: true, key: ch }));
        setNativeValue(el, text.slice(0, i + 1));
        el.dispatchEvent(new InputEvent('input', { bubbles: true, cancelable: true, data: ch, inputType: 'insertText' }));
        el.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, cancelable: true, key: ch }));
        await new Promise(function (r) { setTimeout(r, 35); });
      }
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function submit(el) {
      // Entrée
      ['keydown', 'keypress', 'keyup'].forEach(function (type) {
        el.dispatchEvent(new KeyboardEvent(type, { bubbles: true, cancelable: true, key: 'Enter', code: 'Enter', keyCode: 13, which: 13 }));
      });
      var form = el.closest('form');
      if (form) { bypass = true; try { form.requestSubmit ? form.requestSubmit() : form.submit(); } catch (e) {} setTimeout(function () { bypass = false; }, 400); }
      // Bouton Appliquer
      var btn = findApplyBtn(el);
      if (btn) { bypass = true; try { btn.click(); } catch (e) {} setTimeout(function () { bypass = false; }, 400); }
      return btn;
    }

    try {
      await typeInto(input, code);
      await new Promise(function (r) { setTimeout(r, 200); });
      var btn = submit(input);
      log('applyCodeViaSelly: typed + submit', { value: input.value, btnFound: !!btn, btnText: btn && (btn.textContent || btn.value || '').trim().slice(0, 20) });

      // Filet : si pas appliqué au bout d'1s, on re-tape + re-soumet (champ parfois ré-injecté).
      setTimeout(async function () {
        var app = document.querySelector('#scDiscountApp');
        var applied = app && /sc_simple-info|sc_code-info|RUPTURE/i.test(app.textContent || '');
        if (applied) return;
        var inp2 = findInput();
        if (!inp2) return;
        await typeInto(inp2, code);
        await new Promise(function (r) { setTimeout(r, 150); });
        var b2 = submit(inp2);
        log('applyCodeViaSelly: retry', { value: inp2.value, btnFound: !!b2 });
      }, 1000);
      return true;
    } catch (e) { log('applyCodeViaSelly failed', e); return false; }
  }

  async function addGifts(code, cartArg) {
    if (hasOfferBfCookie()) {
      log('skip add: cookie offre=bf present');
      return;
    }
    const rule = GIFT_RULES[code];
    const prods = ruleProducts(rule);
    // Produits et panier chargés EN PARALLÈLE (les produits ne dépendent pas du panier)
    const productsP = Promise.all(prods.map(p =>
      (p.handle && p.handle !== 'REMPLIR-HANDLE-ICI') ? getProduct(p.handle) : Promise.resolve(null)
    ));
    const cart = cartArg || await getCart();
    const productDatas = await productsP;
    // Tout-ou-rien : on résout la variante de CHAQUE produit offert ; une rupture = aucun ajout.
    const variantIds = [];
    for (let i = 0; i < prods.length; i++) {
      const variantId = await resolveGiftVariantId(prods[i], cart, code, productDatas[i]);
      if (variantId === 'OOS') {
        showGiftUnavailable(rule.name);
        // Option : remplacer le cadeau indisponible par un code promo de repli (ex. DESOLE -30%).
        // Configuré par cadeau via le champ `code_remplacement` du métaobjet gift_code_rule.
        // On l'applique VIA LE CHAMP SELLY (#scDiscountApp) : seul ce chemin déclenche le recalcul
        // de l'app et la bascule du thème vers le footer "aveccode" qui affiche le total remisé.
        if (rule.fallbackCode) {
          applyCodeViaSelly(rule.fallbackCode);
        }
        return { added: false, oos: true };
      }
      if (!variantId) { log('no available variant -> skip add', { code }); return { added: false, oos: false }; }
      variantIds.push(variantId);
    }
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: variantIds.map(id => ({
          id: id,
          quantity: rule.quantity || 1,
          properties: { [GIFT_PROP]: code },
        })),
      }),
    });
    if (!r.ok) { console.warn('[gift-with-code] add failed', await r.text()); return { added: false, oos: false }; }
    clearOosMessage(); // le cadeau est finalement dispo -> on retire un éventuel message de rupture
    window.__gwGiftAddedAt = Date.now(); // marque l'ajout (sync ne retirera pas ce cadeau frais)
    return { added: true, oos: false };
  }

  async function removeGifts(cart, code) {
    const updates = {};
    cart.items.forEach(item => {
      if (item.properties && item.properties[GIFT_PROP] === code) {
        updates[item.key] = 0;
      }
    });
    if (!Object.keys(updates).length) return;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
  }

  // Met à jour le contenu du panier + la pastille SANS ouvrir le drawer.
  // (On évite drawer.renderContents() : dans Dawn il appelle this.open() -> le panier s'ouvre tout seul,
  //  ce qui est indésirable quand le cadeau est (dé)synchronisé en arrière-plan, ex. arrivée sur /maillot.)
  // On fait un simple swap d'innerHTML, qui préserve l'état ouvert/fermé du drawer.
  async function refreshCartUI() {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' });
      const sections = await res.json();
      if (sections['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const src = doc.querySelector('#CartDrawer');
        const dst = document.querySelector('#CartDrawer');
        if (src && dst) dst.innerHTML = src.innerHTML;
        const sd = doc.querySelector('cart-drawer');
        const dd = document.querySelector('cart-drawer');
        if (sd && dd) dd.classList.toggle('is-empty', sd.classList.contains('is-empty'));
      }
      if (sections['cart-icon-bubble']) {
        const doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const sec = doc2.querySelector('.shopify-section');
        const inner = sec ? sec.innerHTML : null;
        if (inner != null) ['cart-icon-bubble', 'cart-icon-bubble2'].forEach(id => {
          const el = document.getElementById(id);
          if (el) el.innerHTML = inner;
        });
      }
      // Le swap d'innerHTML retire le message rupture s'il était là -> on le ré-insère (il doit persister).
      renderOosMessage();
      return;
    } catch (e) {
      console.warn('[gift-with-code] drawer refresh failed', e);
    }
    if (window.location.pathname.startsWith('/cart')) {
      window.location.reload();
    }
  }

  async function sync() {
    if (busy) return;
    busy = true;
    try {
      let cart = await getCart();
      const code = getActiveCode(cart);
      // Code "armé" = cadeau ajouté (ex. injecté dans le /cart/add du produit) mais dont le code promo
      // n'est pas ENCORE appliqué. Il ne faut surtout pas retirer ce cadeau pendant l'application du code.
      let armedCode = '';
      try { armedCode = (sessionStorage.getItem('gwArmedCode') || '').toUpperCase(); } catch (e) {}
      // Garde-fou : un cadeau ajouté il y a < 12s est "frais" (code peut être en cours d'application) -> on ne le retire pas.
      const justAdded = (Date.now() - (window.__gwGiftAddedAt || 0)) < 12000;
      let changed = false;

      for (const c of Object.keys(GIFT_RULES)) {
        if (c === code) continue;
        if (c === armedCode) continue; // code en cours d'application -> on garde son cadeau
        if (justAdded) continue;       // cadeau fraîchement ajouté -> on attend que le code s'applique
        if (giftLinesFor(cart, c).length) {
          await removeGifts(cart, c);
          changed = true;
        }
      }

      if (code) {
        if (changed) cart = await getCart();
        if (!giftLinesFor(cart, code).length && shouldAddGift(GIFT_RULES[code], cart, code)) {
          await addGifts(code, cart);
          changed = true;
        }
      }

      log('sync done', { code, changed });
      if (changed) await refreshCartUI();
    } catch (e) {
      console.error('[gift-with-code] sync error', e);
    } finally {
      busy = false;
    }
  }

  function debounce(fn, ms) {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }
  const debouncedSync = debounce(sync, 400);

  window.addEventListener('sc:discount.calculated', debouncedSync);
  window.addEventListener('sc:discount.remove', debouncedSync);

  // === Pré-ajout : injecter le cadeau AVANT que Shop Circle valide le code ===
  // Sans ça, le code est rejeté ("non valide pour les articles de votre panier")
  // car la culotte cadeau n'est pas encore dans le panier.
  function findCodeInputNear(el) {
    const container = el.closest('form, .sc_discount-app, #scDiscountApp, [class*="discount"], [class*="code"]') || document;
    const candidates = container.querySelectorAll(
      'input[name="discount"], input[name*="discount" i], input[name*="code" i], ' +
      'input[placeholder*="code" i], input[placeholder*="promo" i], ' +
      'input[class*="discount" i], input[class*="code" i], ' +
      'input[type="text"], input:not([type])'
    );
    for (const inp of candidates) {
      const v = (inp.value || '').trim().toUpperCase();
      if (v && GIFT_RULES[v]) return { input: inp, code: v };
    }
    return null;
  }

  let bypass = false;

  // Relance l'action utilisateur (clic/submit) en évitant que notre intercepteur ne la recapte.
  function reclick(triggerEl) {
    bypass = true;
    setTimeout(() => {
      if (triggerEl.tagName === 'BUTTON' || triggerEl.tagName === 'INPUT' || triggerEl.getAttribute('role') === 'button') {
        triggerEl.click();
      } else if (triggerEl.form) {
        triggerEl.form.requestSubmit ? triggerEl.form.requestSubmit() : triggerEl.form.submit();
      }
      bypass = false;
    }, 150);
  }

  async function preAddIfGiftCode(triggerEl, originalEvent) {
    if (bypass) return false;
    const hit = findCodeInputNear(triggerEl);
    if (!hit) return false;

    // IMPORTANT : bloquer la validation Selly TOUT DE SUITE (avant tout await). Sinon Selly traite le
    // code cadeau pendant nos await et affiche "code pas valide" (le cadeau n'est pas encore au panier).
    originalEvent.preventDefault();
    originalEvent.stopImmediatePropagation();

    const cart = await getCart();
    if (giftLinesFor(cart, hit.code).length) { reclick(triggerEl); return true; } // déjà là -> laisse Selly valider

    let res;
    try {
      res = await addGifts(hit.code, cart);
    } catch (e) {
      console.error('[gift-with-code] pre-add failed', e);
      reclick(triggerEl);
      return true;
    }

    // Taille en rupture -> message + code de repli déjà gérés dans addGifts (via le champ Selly).
    // On NE relance PAS le code cadeau (Selly afficherait l'erreur "code pas valide") ; applyCodeViaSelly
    // remplace de toute façon la saisie de l'utilisateur par le code de repli (ex. RUPTURE30).
    if (res && res.oos) return true;

    // Cadeau ajouté -> relance pour que Selly revalide et accepte le code cadeau.
    reclick(triggerEl);
    return true;
  }

  document.addEventListener('click', (e) => {
    if (bypass) return;
    // IMPORTANT : la nouvelle UI Selly "cube" rend "Appliquer/Anwenden" comme <input type="button">
    // (et parfois un <div class="sc_code-btn">) -> il faut les inclure, sinon e.target.closest() renvoie
    // null et le handler s'arrête avant tout (cadeau jamais re-ajouté à la re-saisie du code).
    const btn = e.target.closest('button, input[type="submit"], input[type="button"], input[type="image"], [role="button"], a, .sc_code-btn, #scDiscountApp [class*="btn" i]');
    if (!btn) return;
    const txt = (btn.textContent || btn.value || '').trim().toLowerCase();
    // "Appliquer" multilingue (le thème est servi par marché : DE=Anwenden, ES/PT=Aplicar, IT=Applica,
    // NL=Toepassen, PL=Zastosuj, RO=Aplică, SE=Använd/Tillämpa…). Sans ça, sur .de etc. le clic n'était
    // pas reconnu -> le cadeau n'était pas re-ajouté avant la validation du code -> "code non valide".
    const APPLY_RE = /appliqu|apply|valid|anwend|einlös|toepass|aplica|applica|zastos|aplik|tillämp|använd|anvand|použí|pouzi|alkalmaz|primeni|primijen|uporab|aktiv|absend|einset|ok\b/i;
    // Robuste : tout clic DANS l'app de code promo (Selly ou natif) déclenche le check (no-op s'il n'y a
    // pas de code cadeau saisi, cf. findCodeInputNear dans preAddIfGiftCode).
    const inDiscountScope = !!btn.closest('#scDiscountApp, .scDiscount, .sc_discount-app, [class*="discount" i], [class*="promo" i], [class*="coupon" i], [class*="rabatt" i], [class*="gutschein" i]');
    const looksLikeApply = APPLY_RE.test(txt) ||
      btn.matches('[class*="apply" i], [class*="discount" i], [class*="code" i]') ||
      inDiscountScope;
    if (!looksLikeApply) return;
    log('click apply candidate', { txt: txt.slice(0, 30), btn });
    preAddIfGiftCode(btn, e);
  }, true);

  window.__giftWithCode = {
    sync, addGifts, getCart, GIFT_RULES,
    onDiscountActivation, onCartMutation,
    giftItemsForAdd,
  };

  document.addEventListener('keydown', (e) => {
    if (bypass) return;
    if (e.key !== 'Enter') return;
    const inp = e.target;
    if (!(inp instanceof HTMLInputElement)) return;
    const v = (inp.value || '').trim().toUpperCase();
    if (!GIFT_RULES[v]) return;
    preAddIfGiftCode(inp, e);
  }, true);

  // Hooks appelés par le wrap fetch défini dans theme.liquid (qui est en place plus tôt).
  async function onDiscountActivation(code, proceed) {
    log('intercept /discount/', { code });
    let added = false, oos = false, hadGift = false;
    try {
      const cart = await getCart();
      hadGift = giftLinesFor(cart, code).length > 0; // cadeau déjà présent (injecté dans le /cart/add du produit)
      if (!hadGift && shouldAddGift(GIFT_RULES[code], cart, code)) {
        const res = await addGifts(code, cart);
        oos = !!(res && res.oos);
        added = !!(res && res.added);
        log('pre-add result', { code, added, oos });
      }
    } catch (e) {
      console.error('[gift-with-code] pre-add failed', e);
    }
    // Taille en rupture -> on N'applique PAS le code (évite l'erreur "code pas valide"), message déjà affiché
    if (oos) return new Response('{}', { status: 200, headers: { 'Content-Type': 'application/json' } });
    const result = await proceed();
    // Re-render pour refléter le code appliqué (cadeau gratuit), qu'il vienne d'être ajouté ici
    // ou injecté plus tôt dans le /cart/add du produit (merge).
    if (added || hadGift) { refreshCartUI(); setTimeout(() => refreshCartUI(), 350); }
    return result;
  }

  function onCartMutation() {
    debouncedSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(sync, 1200));
  } else {
    setTimeout(sync, 1200);
  }
})();
